import { parseQuantityConditional, stripOuterParentheses } from "./quantityRuleUtils";

export function splitVectorParts(value) {
  const source = String(value ?? "").trim();
  let depth = 0;
  let quote = null;
  let escaped = false;
  let start = 0;
  const parts = [];
  for (let index = 0; index < source.length; index += 1) {
    const character = source[index];
    if (quote) {
      if (escaped) escaped = false;
      else if (character === "\\") escaped = true;
      else if (character === quote) quote = null;
    } else if (character === '"' || character === "'") quote = character;
    else if ("([{".includes(character)) depth += 1;
    else if (")]}".includes(character)) depth -= 1;
    else if (character === "," && depth === 0) {
      parts.push(source.slice(start, index).trim());
      start = index + 1;
    }
  }
  parts.push(source.slice(start).trim());
  return parts;
}

export function unwrapVector(value) {
  const source = String(value ?? "").trim();
  if (!source.startsWith("[") || !source.endsWith("]")) return source;
  // Only remove a single enclosing pair, never brackets from separate vectors.
  if (splitVectorParts(source).length !== 1) return source;
  let depth = 0;
  for (let index = 0; index < source.length; index += 1) {
    if (source[index] === "[") depth += 1;
    if (source[index] === "]") depth -= 1;
    if (depth === 0 && index < source.length - 1) return source;
  }
  return source.slice(1, -1);
}

export function parseVector(value, fallback = "0") {
  const source = stripOuterParentheses(value);
  if (parseQuantityConditional(source)) return null;
  const parts = splitVectorParts(unwrapVector(source));
  if (parts.length > 3 || parts.some((part) => part.startsWith("["))) return null;
  return Array.from({ length: 3 }, (_, index) => parts[index] || fallback);
}

export function serializeVector(value, fallback = "0,0,0") {
  const source = String(value ?? "").trim() || fallback;
  if (source.startsWith("[") || parseQuantityConditional(source)) return source;
  return `[${source}]`;
}
